<template>
  <div
    class="results-panel"
    :style="panelStyle"
  >
    <button class="back-btn" @click="$emit('back')">Назад к меню</button>

    <div v-if="!currentCategory" class="waiting">
      <p>Администратор ещё не запустил номер...</p>
    </div>

    <div v-else class="active-layout">
      <div class="left-score">
        <div class="result-box">
          <div v-if="allScoresFilled" class="average-score">
            {{ averageScore === 10 ? '10' : averageScore.toFixed(1) }}
          </div>
          <div v-else class="spinner">
            <div class="loader"></div>
          </div>
        </div>
      </div>

      <div class="right-info">
        <div class="info-card">{{ categoryParts[0] }}</div>
        <!-- последняя часть сверху -->
        <div class="info-card">{{ categoryParts[1] }}</div>
        <!-- средняя -->
        <div class="info-card">{{ categoryParts[2] }}</div>
        <!-- первая часть снизу -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResultsPanel",
  props: {
    eventName: { type: String, required: true },
  },
  data() {
    return {
      ws: null,
      connected: false,
      currentData: {},
      currentCategory: null,
      isActive: true,
      backgroundUrl: null,
    };
  },
  computed: {
    safeEventName: function () {
      // Совместимый вариант без \p{L} и флага u — для старых iPad/Safari
      return this.eventName.replace(/[^a-zA-Z0-9а-яА-ЯёЁ\s._-]/g, '');
    },

    panelStyle: function () {
      if (this.backgroundUrl) {
        return {
          backgroundImage: 'url(' + this.backgroundUrl + ')',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',          // всегда contain, как просил
          backgroundColor: 'black',
        };
      }
      // Если фона нет — просто чёрный экран
      return {
        backgroundColor: 'black',
      };
    },

    categoryParts: function () {
      if (!this.currentCategory) return ["—", "—", "—"];
      var parts = this.currentCategory.split("•").map(function (p) { return p.trim(); });
      var len = parts.length;
      return [
        len > 2 ? parts[2] : "—",
        len > 1 ? parts[1] : "—",
        len > 0 ? parts[0] : "—",
      ];
    },

    allScoresFilled: function () {
      if (!this.currentData || !this.currentCategory) return false;
      var judges = this.currentData[this.currentCategory];
      if (!judges) return false;
      return Object.values(judges).every(function (s) {
        return s !== null && s !== undefined;
      });
    },

    averageScore: function () {
      if (!this.allScoresFilled) return 0;
      var scores = Object.values(this.currentData[this.currentCategory])
        .filter(function (s) { return typeof s === "number"; });
      return scores.length > 0
        ? scores.reduce(function (a, b) { return a + b; }, 0) / scores.length
        : 0;
    },

    filledCount: function () {
      if (!this.currentData || !this.currentCategory) return 0;
      return Object.values(this.currentData[this.currentCategory])
        .filter(function (s) { return s !== null && s !== undefined; }).length;
    },

    totalJudges: function () {
      if (!this.currentData || !this.currentCategory) return 0;
      return Object.keys(this.currentData[this.currentCategory]).length;
    },
  },
  mounted: function () {
    console.log("[ResultsPanel] Компонент смонтирован для события: " + this.eventName);
    this.checkAndSetBackground();
    this.connectWebSocket();
  },
  watch: {
    eventName: function (newVal) {
      if (newVal) this.checkAndSetBackground();
    }
  },
  beforeDestroy: function () {
    console.log("[ResultsPanel] Компонент уничтожается – закрываем WebSocket");
    this.isActive = false;
    if (this.ws) {
      this.ws.onclose = null;
      this.ws.onerror = null;
      this.ws.close();
    }
  },
  methods: {
    checkAndSetBackground: function () {
      var self = this;
      var fileName = encodeURIComponent(this.safeEventName) + '.jpg';
      var url = '/dance_data/backgrounds/' + fileName;

      // Пробуем современный fetch (если поддерживается)
      if (typeof fetch === 'function') {
        fetch(url, { method: 'HEAD' })
          .then(function (res) {
            if (res.ok) {
              self.backgroundUrl = url + '?t=' + Date.now();
              console.log("[ResultsPanel] Фон найден и применён: " + self.backgroundUrl);
            } else {
              console.log("[ResultsPanel] Фон не найден: " + url);
              self.backgroundUrl = null;
            }
          })
          .catch(function (err) {
            console.warn("[ResultsPanel] Ошибка проверки фона (fetch):", err);
            self.backgroundUrl = null;
          });
      } else {
        // Старый способ для очень старых браузеров (если нужно)
        var xhr = new XMLHttpRequest();
        xhr.open('HEAD', url, true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status >= 200 && xhr.status < 300) {
              self.backgroundUrl = url + '?t=' + Date.now();
              console.log("[ResultsPanel] Фон найден (XHR): " + self.backgroundUrl);
            } else {
              console.log("[ResultsPanel] Фон не найден (XHR статус " + xhr.status + ")");
              self.backgroundUrl = null;
            }
          }
        };
        xhr.onerror = function () {
          console.warn("[ResultsPanel] XHR ошибка");
          self.backgroundUrl = null;
        };
        xhr.send();
      }
    },

    connectWebSocket: function () {
      var protocol = location.protocol === "https:" ? "wss:" : "ws:";
      var wsUrl = protocol + "//" + location.host + "/ws-dance";

      console.log("[ResultsPanel] Подключение к WebSocket: " + wsUrl);
      this.ws = new WebSocket(wsUrl);
      this.connected = false;

      this.ws.onopen = function () {
        this.connected = true;
        console.log("[ResultsPanel] WebSocket подключён");
        this.ws.send(JSON.stringify({
          action: "subscribe",
          event: this.eventName,
        }));
      }.bind(this);

      this.ws.onmessage = function (e) {
        var msg = JSON.parse(e.data);
        console.log("[ResultsPanel] Получено сообщение:", msg);

        if (msg.type === "init" && msg.data) {
          this.currentData = msg.data;
          this.updateCategory();
        }
        if (msg.type === "patch" && msg.changes) {
          this.applyPatch(msg.changes);
        }
      }.bind(this);

      this.ws.onclose = function () {
        this.connected = false;
        console.log("[ResultsPanel] WebSocket закрыт");

        if (this.isActive) {
          console.log("[ResultsPanel] Переподключаемся через 2 секунды...");
          setTimeout(function () { this.connectWebSocket(); }.bind(this), 2000);
        } else {
          console.log("[ResultsPanel] Компонент уничтожен — переподключение отменено");
        }
      }.bind(this);

      this.ws.onerror = function (err) {
        console.warn("[ResultsPanel] Ошибка WebSocket", err);
        this.connected = false;
      }.bind(this);
    },

    updateCategory: function () {
      var categories = Object.keys(this.currentData);
      if (categories.length > 0) {
        this.currentCategory = categories[0];
        console.log("[ResultsPanel] Активная номинация: " + this.currentCategory);
      } else {
        this.currentCategory = null;
      }
    },

    applyPatch: function (changes) {
      for (var category in changes) {
        if (!this.currentData[category]) this.currentData[category] = {};
        Object.assign(this.currentData[category], changes[category]);
      }
      this.updateCategory();
    },
  },
};
</script>

<style scoped>
.results-panel {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  margin: 0;
  text-align: center;
  font-family: Arial, sans-serif;
}

/* Остальные стили без background — он теперь в :style */
.active-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: relative;
  margin-right: 20vw;
  margin-top: 10vh;
}

.left-score {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right-info {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 65%;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.info-card {
  background: rgb(144, 144, 144);
  color: #fff;
  padding: 14px 18px;
  border-radius: 12px;
  font-size: 1.8vw;
  font-weight: bold;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  text-align: center;
  width: 24vw;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.average-score {
  font-size: 6vw;
  font-weight: bold;
  color: #b80000;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
  padding: 20px 40px;
}

.average-score::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 160%;
  background: radial-gradient(circle, rgb(255, 255, 255) 70%, rgba(255, 255, 255, 0.975) 80%);
  filter: blur(20px);
  z-index: -1;
  border-radius: 50%;
}

.spinner .loader {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.5s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.back-btn {
  margin: 20px;
  padding: 10px 20px;
  background: #666;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
}

.waiting {
  margin-top: 50px;
  color: #999;
  font-size: 20px;
}
</style>